import axios from 'axios';

function createConfig(data) {
  return data?.signal ? { signal: data.signal } : {};
}

function handleError(dispatch, error) {
  if (axios.isCancel(error) || error.code === 'ERR_CANCELED') {
    throw error;
  }

  if(error.response?.status === 401) {
    dispatch('botSingOut');
    dispatch('signOut');
    window.location.replace('/login');
  }
  else throw error;
}

export default {
    state: () => ({}),
    mutations: {},
    actions: {
      post({dispatch}, data){
        return axios.post(window.location.origin +'/ui/v1/' + data.table + '/' + data.method, data.body, createConfig(data))
          .catch(error => handleError(dispatch, error));
      },

      postAPI({dispatch}, data){
        return axios.post(window.location.origin +'/api/v1/' + data.controller + '/' + data.method, data.body, createConfig(data))
          .catch(error => handleError(dispatch, error));
      },

      getAPI({dispatch}, data){
        return axios.get(window.location.origin +'/api/v1/' + data.controller + '/' + data.method, createConfig(data))
          .catch(error => handleError(dispatch, error));
      },

      delete({dispatch}, data){
        return axios.delete(window.location.origin +'/ui/v1/' + data.table + '/' + data.method, {
          ...createConfig(data),
          data: data.body,
        }).catch(error => handleError(dispatch, error));
      },
  
      get({dispatch}, data){
        return axios.get(window.location.origin +'/ui/v1/' + data.table + '/' + data.method, createConfig(data))
          .catch(error => handleError(dispatch, error));
      },

      getV2({dispatch}, data){
        return axios.get(window.location.origin +'/ui/v2/' + data.table + '/' + data.method + '?' + data.query, createConfig(data))
          .catch(error => handleError(dispatch, error));
      },
  
      add({dispatch}, data){
        return dispatch("post", { table: data.table, method: "add", body: data.body });
      },
      update({dispatch}, data){
        return dispatch("post", { table: data.table, method: "update", body: data.body });
      },
      remove({dispatch}, data){
        return dispatch("delete", { table: data.table, method: "remove?id=" + data.body.id });
      },
      
      index({dispatch}, data) {
        const queryObj = data.body ?? {};
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(queryObj)) {
          if (value != null && value !== '') {
            params.append(key, value);
          }
        }
        
        const method = 'index' + (params.toString() ? `?${params.toString()}` : '');
        return dispatch("get", { table: data.table, method: method, signal: data.signal });
      },
      section({dispatch}, data){
        return dispatch("get", { table: data.table, method: 'section' });
      },
      pagination({ dispatch }, data) {
            return dispatch("post", { table: data.table, method: 'pagination/' + data.query.page, body: data.query.filters.map(function (x) { return { Value: x.value, Field: x.field, Operation: x.type }; }) });
      },
      sectionV2({dispatch}, data){
        return dispatch("getV2", { table: data.table, method: 'section', query: 'page='+data.query.page+"&size="+data.query.size });
      },
      getFilter({dispatch}, data) {
        return dispatch("get", { table: data.table, method: 'filter?id=' +  data.body.id+'&rootColumn=' + data.body.rootColumn, signal: data.signal});
      }
    },
    modules: {},
    getters: {},
  };
  
